import { SerializedAnnotationLaw } from 'server-response-types';

export default class AnnotationLaw {
    public readonly id: number;
    public readonly name: string;
    public readonly url: string;
    public readonly type: string;
    public readonly created_date: string;
    public readonly updated_date: string;
    public readonly raw_url: string;
    public readonly labels: string;

    constructor(initialData: SerializedAnnotationLaw) {
        const data = {
            id: undefined,
            name: undefined,
            url: undefined,
            type: undefined,
            created_date: undefined,
            updated_date: undefined,
            raw_url: undefined,
            labels: undefined,
        };

        for (const key of Object.keys(data)) {
            if (Object.prototype.hasOwnProperty.call(initialData, key)) {
                data[key] = initialData[key];
            }
        }

        Object.defineProperties(
            this,
            Object.freeze({
                id: {
                    get: () => data.id,
                },
                name: {
                    get: () => data.name,
                },
                url: {
                    get: () => data.url,
                },
                type: {
                    get: () => data.type,
                },
                created_date: {
                    get: () => data.created_date,
                },
                updated_date: {
                    get: () => data.updated_date,
                },
                raw_url: {
                    get: () => data.raw_url,
                },
                labels: {
                    get: () => data.labels,
                },
            }),
        );
    }

    toJSON(): SerializedAnnotationLaw {
        const object: SerializedAnnotationLaw = {
            id: this.id,
            name: this.name,
            url: this.url,
            type: this.type,
            created_date: this.created_date,
            updated_date: this.updated_date,
            raw_url: this.raw_url,
            labels: this.labels,
        };

        if (this.name) {
            object.name = this.name;
        }

        if (this.url) {
            object.url = this.url;
        }

        if (this.type) {
            object.type = this.type;
        }

        if (this.created_date) {
            object.created_date = this.created_date;
        }

        if (this.updated_date) {
            object.updated_date = this.updated_date;
        }

        if (this.raw_url) {
            object.raw_url = this.raw_url;
        }

        if (this.labels) {
            object.labels = this.labels;
        }

        return object;
    }
}
